import CalendarSlide from '../CalendarSlide'

export default function BookCallEngineerSlide (props) {
  return (
    <CalendarSlide
      id='book-call-slide'
      stageName='Finding your place at Aragon'
      title={'Meet our Engineers'}
      description={
        "If you're interested in the Technical position, here you can schedule a call to talk to our team. This is a great step in gaining a better understanding of the role and learning more."
      }
      calendalyUrl={'https://calendly.com/catapultlabs'}
      thumb={'imgs/products/client.png'}
      cardTitle={'Aragon Engineering call'}
      cardSubtitle={'Visiting team weekly call'}
      showProgress={false}
      {...props}
    />
  )
}
